<template>
  <header>
    <nav class="navbar navbar-expand-md"><div class="container-fluid">
        <router-link to="/Home" class="navbar-brand"
          ><img
            src="https://snippcheck.blob.core.windows.net/files/wkkc_special_k_athletic_2007824/logo.png"
            alt="logo"
            class="img-fluid"
        /></router-link>
        <button
          class="navbar-toggler"
          type="button"
          @click="toggleCollapse"
          aria-controls="navbar-Nav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        ><img src="https://snippcheck.blob.core.windows.net/files/wkkc_special_k_athletic_2007824/hamburger_icon.png" width="45" /></button>
        <div
          :class="{ show: isCollapsed }"
          class="collapse navbar-collapse justify-content-between my-2 align-items-center"
          id="navbar-Nav"
        >
          <ul class="navbar-nav me-auto ">
            <li class="nav-item">
              <router-link to="/Home" class="nav-link text-uppercase"
                >Home</router-link
              >
            </li>
			<li class="nav-item">
              <router-link to="/Upload" class="nav-link text-uppercase">Upload</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/Support" class="nav-link text-uppercase"
                >Support</router-link
              >
            </li>
          </ul><div class="toogle-country-list mb-3 mb-md-0">
          <ul class="list-inline">
            <li class="active"><a :href="getLanguageLink('en')">EN</a></li>
			<li><a :href="getLanguageLink('es')">ES</a></li>
          </ul>
        </div>          
        </div>		
      </div>
    </nav>
  </header>

  <banner></banner>
</template>

<script>
import banner from '../UI/Banner.vue';
export default {
  components: { banner },
  data() {
    return {
      isCollapsed: false,
    };
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
	getLanguageLink(languageCode) {
      const currentPath = this.$route.path;
      const currentHost = window.location.hostname;
      let baseUrl;

      // Determine environment based on hostname
      const isStaging = currentHost.includes('staging');

      if (languageCode === 'en') {
        baseUrl = isStaging
          ? 'https://staging-wkkcAthleticApparel.snipp.us'  // Staging URL for English
          : 'https://skactivewear.com';          // Production URL for English
      } else if (languageCode === 'es') {
        baseUrl = isStaging
          ? 'https://staging-wkkcAthleticApparel-es.snipp.us'   // Staging URL for Spanish
          : 'https://es.skactivewear.com';          // Production URL for Spanish
      }

      return `${baseUrl}${currentPath}`;
    }
  },
};
</script>

<style scoped>
header {
	width: 100%;
}
#navbar-Nav > ul > li a {
	color: #404040;
	line-height: 1;
}
.navbar-brand {
	width: 13%;
}
.list-inline > li {
	display: inline-block;
	padding-left: 5px;
	padding-right: 5px;
}
.list-inline > li.active{
	border-bottom: 1px solid #48657c;
}
.social-icon {
	font-size: 2rem;
	border-radius: 5px;
	color: #f26a32;
}
.nav-link {
	background: transparent;
	cursor: pointer;
	color: #000;
	display: inline-block;
	text-decoration: none;
	border-bottom: 2px solid transparent;
}
.nav-link:hover,.nav-link:active,.nav-link.active {
	color: #000;
	border-bottom: 2px solid #bf233a;
}
.toogle-country-list ul {
	padding: 0;
	margin: 0;
}
.toogle-country-list ul li a {
	font-weight: 700;
	color: #48657c;
	text-transform: uppercase;
	width: auto;
	display: block;
	white-space: nowrap;
	overflow: hidden;
	text-decoration: none;
}
.top-social-nav a:hover {
	color: #176198;
}
@media screen and (max-width: 767px) {
	header{
		position: absolute;
		z-index: 1;
	}
	.navbar{
		padding: 0px;
	}
	.navbar-brand {
		visibility: hidden;
	}
	.navbar-toggler{
		padding: 0px;
		border: 0px;
		z-index: 1;
	}
	.navbar-toggler:focus{
		box-shadow: none;
	}
	#navbar-Nav{
		position: absolute;
		top: 0;
		left: 0;
		background: #fff;
		padding-top: 50px;
		text-align: left;
		width: 100%;
		margin: 0 !important;
	}
	.top-social-nav {
		display: flex;
		justify-content: center;
		margin-top: 11px;
	}
	.toogle-country-list {
		margin: 12px 0 0 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 0 auto;
	}
	ul.navbar-nav {
		width: 100% !important;
		display: block !important;
	}
	.navigation {
		margin-left: 0px !important;
	}
	.navigation img {
		max-width: 100%;
	}
	ul.navbar-nav {
		display: inline;
		margin: 0 auto;
		text-align: center;
	}
	ul.navbar-nav li {
		display: block;
		margin: 0 !important;
	}
}
</style>
